import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import CustomLink from '../../CustomLink';
import BfHeader from './BfHeader';
import { BF_LEAD_CAMPAIGN } from './useLeadSignup';
import './BlackFriday.css';

const KEY = 'BF_LG_';

// Small confirmation shown right after sign-up: confirm the email, then push into the quiz.
const BlackFridayThankYou = () => {
  const { t } = useTranslation();

  return (
    <>
      <BfHeader />
    <main className="bflg bflg-ty">
      <Helmet>
        <title>{t(`${KEY}TyMetaTitle`)}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section className="bflg-ty__card">
        <span className="bflg-ty__check" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
        </span>
        <h1>{t(`${KEY}TyHeading`)}</h1>
        <p className="bflg-ty__body">{t(`${KEY}TyBody`)}</p>

        <div className="bflg-ty__next">
          <h2>{t(`${KEY}TyNextHeading`)}</h2>
          <p>{t(`${KEY}TyNextBody`)}</p>
          <CustomLink
            to={`/quiz?utm_campaign=${BF_LEAD_CAMPAIGN}&utm_source=bf_early`}
            className="bflg-btn"
          >
            {t(`${KEY}TyCta`)}
            <span aria-hidden="true">→</span>
          </CustomLink>
        </div>
      </section>
    </main>
    </>
  );
};

export default BlackFridayThankYou;
